import React, { forwardRef } from 'react';
import {
  Turnstile,
  TurnstileInstance,
  TurnstileProps,
} from '@marsidev/react-turnstile';

import { getTurnstileLanguage, getTurnstileKey } from 'services/cloudflare';

type Ref = TurnstileInstance | undefined;
type Props = Omit<TurnstileProps, 'siteKey'> & { siteKey?: string };

const TURNSTILE_KEY = getTurnstileKey();
const language = getTurnstileLanguage();
const TurnstileWidget = forwardRef<Ref, Props>(({ options, ...props }, ref) => {
  return (
    <Turnstile
      {...props}
      ref={ref}
      injectScript={false}
      siteKey={TURNSTILE_KEY}
      options={{
        theme: 'light',
        size: 'flexible',
        language,
        ...options,
      }}
    />
  );
});

TurnstileWidget.displayName = 'TurnstileWidget';

export { TurnstileWidget };
export type { Ref, Props };
